export * from './power-resource-needed.component';



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/page-creep-level.module/power-resource-needed.component/index.ts